import { useLocation } from '@reach/router';

export const useQuery = (queryParamKey: string): string | null => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);

  return urlSearchParams.get(queryParamKey);
};
